import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useState } from 'react';

import AutoCompleteTextBox from '../editor/controls/RightAutoCompleteTextBox';
import RightsZoom from '../editor/controls/RightsZoom';

const useStyles = makeStyles({
  column: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 600,
    alignItems: 'center',
    marginTop: 5,
    marginRight: 35,
  },
});

const RightsRow = ({ isEditMode, leftLabel, rightLabel, leftFieldKey, rightFieldKey }) => {
  const classes = useStyles();
  const [isAutoCompleteLoading, setIsAutoCompleteLoading] = useState({
    [leftFieldKey]: false,
    [rightFieldKey]: false,
  });
  return (
    <>
      <Grid item xs={12} lg={5}>
        <div className={classes.column}>
          <AutoCompleteTextBox
            label={leftLabel}
            prop={leftFieldKey}
            disabled={!isEditMode}
            isAutoCompleteLoading={isAutoCompleteLoading}
            setIsAutoCompleteLoading={setIsAutoCompleteLoading}
          />
          {isEditMode && (
            <RightsZoom prop={leftFieldKey} isAutoCompleteLoading={isAutoCompleteLoading} />
          )}
        </div>
      </Grid>
      <Grid item xs={12} lg={5}>
        <div className={classes.column}>
          <AutoCompleteTextBox
            label={rightLabel}
            prop={rightFieldKey}
            disabled={!isEditMode}
            isAutoCompleteLoading={isAutoCompleteLoading}
            setIsAutoCompleteLoading={setIsAutoCompleteLoading}
          />
          {isEditMode && (
            <RightsZoom prop={rightFieldKey} isAutoCompleteLoading={isAutoCompleteLoading} />
          )}
        </div>
      </Grid>
    </>
  );
};

export default RightsRow;
